<template>
  <div class="addOccupy">
    <el-form ref="form" :model="form" :rules="rules" label-width="96px" label-position="left">
      <el-form-item label="占座数量" prop="occupySeat">
        <el-input v-model="form.occupySeat" maxlength="15" placeholder="请输入占座数量"
                  v-input-filter="{ min: 1, max: 99, precision: 0 }"/>
      </el-form-item>

      <el-form-item label="占座时间" prop="occupySeatTime">
        <el-input v-model="form.occupySeatTime" maxlength="15" placeholder="请输入占座倒计时"
                  v-input-filter="{ min: 1, max: 120, precision: 0 }">
          <template slot="append">分钟</template>
        </el-input>
      </el-form-item>

      <el-form-item label-width="0px">
        <div class="util-remark">
          说明：<br/>
          1.未设置占座时间将不会自动恢复座位<br/>
          2.在占座期间将减少可售票数量<br/>
          3.占座倒计时结束后自动恢复座位<br/>
        </div>
      </el-form-item>

      <el-form-item label-width="0">
        <div class="main-form-btn">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button type="primary" @click="actionFn" :loading="loading">确定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "addOccupy",
  props: {
    loadData: {
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        occupySeat: "",
        occupySeatTime: ""
      },
      rules: {
        occupySeat: [
          {required: true, message: "请输入占座数量", trigger: "blur"},
        ],
      },
      loading: false
    }
  },
  methods: {
    async actionFn() {
      const valid = await this.$refs.form.validate().catch(err => err);
      if (typeof valid === 'boolean' && valid) {
        const url = '/api/v1/manage/line/scheduling/occupy/seat'
        this.loading = true
        const {code} = await this.$axios.post(url, {
          ...this.form,
          schedulingId: this.loadData.schedulingId,
        })
        this.loading = false
        if (code === 1) {
          this.$message.success('操作成功')
          this.form = {
            occupySeat: "",
            occupySeatTime: ""
          }
          this.$emit("handClose")
        }
      }
    }

  }
}
</script>

<style scoped>

</style>